<template>
<div class="px-6 pb-6">

  <v-card class="rounded-lg px-6 py-6" elevation="0" style="border: 1px solid #e0e0e0;">
    <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
      <div class="flex justify-space-between align-center">
        <div>
          <h2 class="text-h5 font-weight-bold grey--text text--darken-3 mb-1">
            Библиотека компетенций
          </h2>
          <div class="text-body-2 grey--text">
            Всего: {{ libraryCompetencies.length }}. Откройте редактор для управления.
          </div>
        </div>

      </div>

      <v-btn
        color="#009E60"
        dark
        depressed
        class="text-capitalize mt-2 mt-sm-0 px-6"
        height="40"
        @click="openLibraryCompetenciesModal"
      >
        <v-icon left small>mdi-pencil</v-icon> Открыть редактор
      </v-btn>
    </div>
    <v-row v-if="libraryCompetencies && libraryCompetencies.length">
      <v-col
        v-for="(competency, index) in libraryCompetencies"
        :key="competency.id != null ? competency.id : index"
        cols="12" sm="6" md="4"
      >
        <CardItem
          :data="competency"
          :type="'competence'"
          :action="false"

        />
      </v-col>
    </v-row>
    <div v-else-if="!libraryCompetencies.length" class="d-flex flex-column align-center py-10">
      <v-icon size="48" color="grey lighten-2">mdi-folder-open-outline</v-icon>
      <p class="text-body-2 grey--text mt-3">Нет созданных компетенций. Нажмите «открыть редактор» для создания.</p>
    </div>
    <v-row v-else>
      <v-col
        v-for="(competency, index) in 4"
        :key="index"
        cols="12" sm="6" md="4"
      >
        <CardItemSkeleton
          :data="competency"
          :type="'competence'"
          :action="false"
        />
      </v-col>
    </v-row>

  </v-card>
</div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CardItem from './CardItem.vue';
import CardItemSkeleton from './CardItemSkeleton.vue';

export default {
  name: 'libraryCompetencies',
  components: { CardItemSkeleton, CardItem },
  computed: {
    ...mapGetters({
      libraryCompetencies: 'diagnostics/diagnotics/libraryCompetencies'
    }),
  },
  methods: {
    ...mapActions({
      deleteCompetency: 'diagnostics/diagnotics/deleteItemCompetency'
    }),
    ...mapMutations({
      SET_COMPETENCIES_MODAL: 'diagnostics/diagnotics/SET_COMPETENCIES_MODAL',
      SET_COMPETENCY_SHOW_MODAL: 'diagnostics/diagnotics/SET_COMPETENCY_SHOW_MODAL',
      SET_COMPETENCY_ID_MODAL: 'diagnostics/diagnotics/SET_COMPETENCY_ID_MODAL',
    }),
    openLibraryCompetenciesModal() {
      this.SET_COMPETENCIES_MODAL(true);
    },
    async deleteItemCompetency(competency) {
      await this.deleteCompetency(competency.id);
    }
  },
  data: () => ({

  })
};
</script>

<style scoped lang="scss">

</style>
